import { render, staticRenderFns } from "./BcSearchList.vue?vue&type=template&id=1477e472"
import script from "./BcSearchList.vue?vue&type=script&lang=js"
export * from "./BcSearchList.vue?vue&type=script&lang=js"
import style0 from "./BcSearchList.vue?vue&type=style&index=0&id=1477e472&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports